import { ReactNode, useState } from 'react';
import { Splitter, SplitterPanel } from 'primereact/splitter';
import { useOrganization } from '@clerk/clerk-react';

export type SplitterMenuProps = {
  menu?: ReactNode;
  isMenuOpen: boolean;
  title: string;
  children: ReactNode;
};
export const SplitterMenu = ({
  menu,
  isMenuOpen = false,
  children,
}: SplitterMenuProps) => {
  const [localOpen, setLocalOpen] = useState(isMenuOpen);
  const { organization } = useOrganization();
  const logoUrl = organization?.imageUrl || '/public/bsc_logo.png';

  if (localOpen) {
    return (
      <Splitter
        key="menu"
        style={{ height: '100vh' }}
        className="w-full splitter-menu-page"
      >
        <SplitterPanel className="bg-gray-light" size={15} minSize={10}>
          <div className="splitter-page-content splitter-left-menu">
            <div className="header">
              <div className="logo-wrapper">
                <img src={logoUrl} alt="logo" className="" />
              </div>
              <div
                className="fold-icon"
                role="button"
                onClick={() => {
                  setLocalOpen(false);
                }}
                tabIndex={0}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="48"
                  height="48"
                  viewBox="0 -960 960 960"
                >
                  <path d="M561-240 320-481l241-241 43 43-198 198 198 198-43 43Z"></path>
                </svg>
              </div>
            </div>
            {menu}
          </div>
        </SplitterPanel>
        <SplitterPanel
          key="content"
          className="basic-page splitter-page-content flex flex-column"
          size={85}
        >
          {/*<h3>{title}</h3>*/}
          {children}
        </SplitterPanel>
      </Splitter>
    );
  } else {
    return (
      <div className="w-full flex">
        <div
          className="w-1rem mt-3 fold-icon"
          role="button"
          onClick={() => {
            setLocalOpen(true);
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 -960 960 960"
          >
            <path d="M530-481 332-679l43-43 241 241-241 241-43-43 198-198Z"></path>
          </svg>
        </div>
        <div className="w-full">
          <div
            className="basic-page splitter-page-content flex flex-column"
            style={{
              height: 'calc(100vh - 20px)',
              flexBasis: 'calc(85% - 4px)',
            }}
          >
            {/*<h3>{title}</h3>*/}
            {children}
          </div>
        </div>
      </div>
    );
  }
};
